import { QuestionStatus } from '@exam-management/graphql';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { Flex, SectionTitle } from '@shared/components';

import { useSingleQuestionDetails } from '../../providers';
import { PropertiesFormSection } from '../properties-form-section';
import { PropertiesView } from '../properties-view';

export default function SingleQuestionPropertiesSection() {
  const { task, roles, status } = useQuestionCreationTaskDetails();
  const { singleQuestion } = useSingleQuestionDetails();

  const isInDevelopment = singleQuestion.status === QuestionStatus.InDevelopment;

  const isEditable =
    isInDevelopment &&
    roles.isAssignee &&
    status.code === QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress;

  return (
    <Flex sx={{ flexDirection: 'column', gap: 4 }}>
      <SectionTitle title='Properties' />
      {isEditable ? (
        <PropertiesFormSection taskId={task.id} questionId={singleQuestion.id} />
      ) : (
        <PropertiesView />
      )}
    </Flex>
  );
}
